import React, { FC } from 'react';
import { FlexCol } from '@minecraft.atoms';
import { appConfig } from '@minecraft.app-config';
import { PAYWALL_STEPS } from '../../enums/paywall';
import { CheckoutProps } from '../../Checkout/types';
import { CheckoutWrapper } from '../../Checkout/CheckoutWrapper';
import { ReactivationConfirmation } from './ReactivationConfirmation';
import { ReactivateSuccess } from './ReactivationSuccess';

export const ReactivationBgWrapper: FC = ({ children }) => {
  return (
    <FlexCol
      w="full"
      backgroundImage={{
        image: `${appConfig.cdnRoot}/images/static/hero-image-ht2-modal.jpg`,
        size: 'cover',
        position: 'right',
        repeat: 'no-repeat',
      }}
    >
      <FlexCol
        gap="6"
        w="full"
        className="cn_atom_p-6"
        justifyItems="center"
        alignItems="center"
        bgColor="maxContrast"
        bgOpacity={0.4}
      >
        {children}
      </FlexCol>
    </FlexCol>
  );
};

type SingleClickReactivationProps = CheckoutProps & {
  step?: PAYWALL_STEPS;
};

export const SingleClickReactivation = ({ step, ...checkoutPropsBag }: SingleClickReactivationProps) => {
  return (
    <FlexCol w="full" justifyContent="center" alignItems="center">
      {PAYWALL_STEPS.SUCCESS === step && (
        <ReactivationBgWrapper>
          <ReactivateSuccess
            completedPurchase={checkoutPropsBag.completedPurchase}
            onDone={checkoutPropsBag.closeBillingPopup}
          />
        </ReactivationBgWrapper>
      )}
      {PAYWALL_STEPS.CHECKOUT === step && <CheckoutWrapper {...checkoutPropsBag} />}
      {![PAYWALL_STEPS.CHECKOUT, PAYWALL_STEPS.SUCCESS].includes(step) && (
        <ReactivationBgWrapper>
          <ReactivationConfirmation
            onChangePayment={checkoutPropsBag.onNext}
            onCompletePurchase={checkoutPropsBag.onCompletePurchase}
            selectedPlan={checkoutPropsBag.selectedPlan}
            plansLoading={checkoutPropsBag.plansLoading}
            completePurchaseLoading={checkoutPropsBag.completePurchaseLoading}
          />
        </ReactivationBgWrapper>
      )}
    </FlexCol>
  );
};
